import styles from './LegalPage.module.css';

export function Impressum() {
  return (
    <div className={styles.legalPage}>
      <h1 className={styles.title}>Legal Notice</h1>
      <p className={styles.lastUpdated}>Disclosure pursuant to the Austrian E-Commerce Act (ECG)</p>

      <div className={styles.content}>
        <h2>Operator</h2>
        <p>
          Wolfgang Pree GMBH<br />
          Karl-Roll-Straße 16<br />
          5020 Salzburg<br />
          Austria
        </p>

        <h2>Contact</h2>
        <p>
          Email: office@AIquadrat.com
        </p>

        {/* Optional: Only if you have a VAT number */}
        {/*
        <h2>VAT ID</h2>
        <p>ATU00000000</p>
        */}

        {/* Optional: Only if registered company */}
        {/*
        <h2>Company Registration</h2>
        <p>FN 000000x, Regional Court [City]</p>
        */}

        <h2>EU Dispute Resolution</h2>
        <p>
          The European Commission provides a platform for online dispute resolution (ODR):{' '}
          <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
            https://ec.europa.eu/consumers/odr
          </a>
        </p>
      </div>
    </div>
  );
}
